export default "__VITE_ASSET__9OLaGAvn__"